import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../environments/environment';

@Injectable()
export class WordpressService {

  apiUrl:string;
  apiBrbaConfig:string;

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) protected localeId: string,
  ) {
    this.apiUrl = environment.uriAPI;
    this.apiBrbaConfig = environment.uriDomain+"/wp-json/brba/v1/config";
  }

  getPosts(): Observable<any[]> {
    // console.log(this.localeId);
    return this.http.get<any[]>(this.apiUrl+'/posts?_embed', {
      params: {
        per_page: '12',
        lang: this.localeId,
      }
    });
  }

  getPages(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl+'/pages?_embed', {
      params: {
        per_page: '12',
        lang: this.localeId,
      }
    });
  }

  getPost(slug:string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl+'/posts?_embed', {
      params: {
        slug: slug,
        per_page: '12',
        lang: this.localeId,
      }
    });
  }

  getPostArtxibo(id): Observable<any[]> {

    return this.http.get<any[]>(this.apiUrl+'/posts?_embed', {
      params: {
        per_page: '12',
        artxibo: id,
        lang: this.localeId,

      }
    });
  }

  getPage(slug:string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl+'/pages?_embed', {
      params: {
        slug: slug,
        per_page: '12',
      }
    });
  }

  // categories
  getCategories(name:string='categories'): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl+'/'+name, {
      params: {
        per_page: '100',
        order: 'asc',
        orderby: 'slug'
      }
    });
  }

  // Users
  getUser(slug:string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl+'/users', {
      params: {
        slug: slug
      }
    })
  }

  getBrbaConfig(): Observable<any[]> {
    return this.http.get<any[]>(this.apiBrbaConfig, {})
  }

  /// install wp rest user for use /register
  createUser(username:string,email:string,password:string,data:any={}) {
    data['username']=username;
    data['email']=email;
    data['password']=password;
    return this.http.post<any[]>(this.apiUrl+'/users/register',data,{});
  }

  recoveryPasswordUser(username:string) {
    return this.http.post<any[]>(this.apiUrl+'/users/lost-password',{user_login:username},{})
  }

  activateUser(username:string,hash:string) {
    return this.http.post<any[]>(environment.apiUrlUserActivation,{username:username,hash:hash},{});
  }

  setUser(id:string,data:any) {
    return this.http.post<any[]>(this.apiUrl+'/users/'+id,{ahum:data},{});
  }

  //SUBSCRIPTIONS
  getSubscriptions():Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrlUserSubscriptions);
  }

}
